
import React from 'react';
import {useState, useEffect} from 'react';
import {PlainText} from './plainText/plainText';

export const MarketEntryTip = ({userId, isAdmin}: {userId: string, isAdmin: boolean}) => {
    const cacheKey = `market_entry_head_${userId}`;
    const cacheStatus = localStorage.getItem(cacheKey) === '1';
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (location.pathname === '/index') {
            setShow(isAdmin && !cacheStatus);
        }
    }, []);

    const onClick = () => {
        setShow(false);
        try {
            localStorage.setItem(cacheKey, '1');
        } catch (err) {
            console.error(err);
        }
    };

    if (!show) {
        return null;
    }
    return (
        <div className="navitem-tip-wrap">
            <div className="market-entry-tip">
                <PlainText>UMU课程市场与众多业内名师、机构深度合作，打造一系列大师级精品课程，为企业提供一站式解决方案。 </PlainText>
                <p><PlainText>此入口仅系统管理员可见。</PlainText></p>
                <div className="market-entry-tip-footer">
                    <button className="guide-btn" onClick={onClick}>
                        <PlainText>我知道了</PlainText>
                    </button>
                </div>
            </div>
        </div>
    );
};
